import { render } from "./Links.vue?vue&type=template&id=5266c70f&ts=true"
import script from "./Links.vue?vue&type=script&lang=ts"
export * from "./Links.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/firebridge_dev/fblogin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__